import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DecisionDocumentsState } from './decision-documents.state';

export const selectDecisionDocumentsState = createFeatureSelector<DecisionDocumentsState>('decisionDocuments');

export const selectLoading = createSelector(selectDecisionDocumentsState, state => state.loading);

export const selectDocuments = createSelector(selectDecisionDocumentsState, state => state.documents);

export const selectRemovingIds = createSelector(selectDecisionDocumentsState, state => state.removingIds);
